import { render, staticRenderFns } from "./MiraSolutions.vue?vue&type=template&id=2c58d1ba&scoped=true"
import script from "./MiraSolutions.vue?vue&type=script&lang=js"
export * from "./MiraSolutions.vue?vue&type=script&lang=js"
import style0 from "./MiraSolutions.vue?vue&type=style&index=0&id=2c58d1ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c58d1ba",
  null
  
)

export default component.exports